import axios from 'axios';
import { Message } from 'element-ui';
import router from '@/router';
import { throttleFn } from './utils';
import { isBlank, isNotBlank } from 'utils/string';

const service = axios.create({
  baseURL: process.env.BASE_URL, //api的base_url
  timeout: 1000 * 60 * 5, //请求超时时间
});
const loginFailure = throttleFn(() => {
  Message({
    message: '账号已过期，请重新登录',
    type: 'error',
    duration: 5 * 1000,
  });
  const targetRoute = router.currentRoute;
  router.replace(`/login?redirect=${targetRoute.fullPath}`);
}, 5000);

service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(new Error(error));
  }
);
service.interceptors.response.use(
  (response) => {
    if (checkStreamOrBlob(response)) {
      handleBlobResp(response);
    } else {
      if (response.data.code !== 200) {
        Message({
          message: response.data.message,
          type: 'error',
          duration: 5 * 1000,
        });
        return Promise.reject(new Error(response.message || 'Error'));
      }
      return response.data;
    }
  },
  (error) => {
    if (error.response) {
      const { status } = error.response;
      if (status === 401) {
        loginFailure();
      } else {
        return Promise.reject(new Error(error));
      }
    } else {
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000,
      });
      return Promise.reject(new Error(error));
    }
  }
);

/**
 * 处理 Blob 文件下载
 * @param response
 */
function handleBlobResp(response) {
  const contentDisposition = response.headers['content-disposition'];
  const contentType = response.headers['content-type'];

  if (isNotBlank(contentType) && contentType.includes('application/json')) {
    const reader = new FileReader();
    reader.onload = () => {
      const result = JSON.parse(reader.result);
      if (result && result.code !== 200) {
        Message({
          message: result.message,
          type: 'error',
          duration: 5 * 1000,
        });
      }
    };
    reader.readAsText(response.data);
    return;
  }
  if (isBlank(contentDisposition)) {
    Message({
      message: '请求异常',
      type: 'error',
      duration: 5 * 1000,
    });
    return;
  }

  let shouldPreview = contentDisposition.includes('inline');
  const fileName = contentDisposition
    ? decodeURIComponent(contentDisposition.split('filename=')[1])
    : 'download';

  let objectUrl;
  const data = response.data;
  if (shouldPreview) {
    // 在新标签页中预览文件
    objectUrl = window.URL.createObjectURL(new Blob([data], { type: contentType }));
    window.open(objectUrl, '_blank');
  } else {
    objectUrl = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = objectUrl;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  window.URL.revokeObjectURL(objectUrl);
}

/**
 * 检查响应数据是否是 Stream 或 Blob
 * @param response
 */
function checkStreamOrBlob(response) {
  const targetContentType = [
    'application/octet-stream',
    'application/zip',
    'application/x-zip-compressed',
    'application/pdf',
  ];
  const targetHeader = ['inline', 'attachment'];
  const responseType = response.config.responseType;
  const headers = response.headers;
  const contentType = headers['content-type'];
  return (
    responseType === 'blob' ||
    targetContentType.includes(contentType?.split(';')[0]) ||
    targetHeader.includes(headers['content-disposition']?.split(';')[0])
  );
}

export default service;
